import axios from "axios";
import { APP_SETTINGS } from "../../config";

function getAllUserToDoListApi(data) {
  return axios.post(APP_SETTINGS.API_PATH.TODO_LIST.getAllUserToDo, data);
}
function createToDoListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO_LIST.CreateToDoList, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  // return axios.post(APP_SETTINGS.API_PATH.TODO_LIST.CreateToDoList, data);
}

export { getAllUserToDoListApi, createToDoListApi };
